import { combineStrings } from 'assets/utils/data/String';
import InputType from 'models/enums/InputType';
import Model from 'models/Model';

export default class ProductEnhancementAdditionalField
  extends Model<Model.IProductEnhancementAdditionalField>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IProductEnhancementAdditionalField>
{
  id: number;
  key: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  group?: string;
  label?: string;
  type?: InputType;
  propertyPath?: string;
  productEnhancementDocumentId?: number;
  defaultValue?: string | number | boolean;

  constructor(
    data: Partial<Model.IProductEnhancementAdditionalField> | Utils.FormData<Model.IProductEnhancementAdditionalField>,
    language?: Locale.Languages
  ) {
    super({}, language);
    this.update(data);
  }

  getDocumentId(): number {
    return this.productEnhancementDocumentId;
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: combineStrings(' | ', this.label, this.key),
      info: this.group,
      subtitle: this.type,
    };
  }
}
